import React, { Component } from 'react';
import Header from '../../layout/header/header'
import Footer from '../../layout/footer/footer'
import '../nearme/nearme.css';
class nearme extends Component {
    render() {
        return (
            <div>
                <Header/>
                   {/* <!-- near me start --> */}
    <div className="near_me">
        <div className="container-fluid">
            <h2>Services Near me</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt<br/>
                 ut labore et dolore magna aliqua.</p>
        </div>
    </div>
    <div className="near_me_inr">
        <div className="container-fluid">
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>
            <div className="near_me_btn">
                <a href="#">Ac Repairing Near me</a>
            </div>

        </div>
    </div>

    {/* <!-- near me end --> */}
    <Footer/>
            </div>
        );
    }
}

export default nearme;
